import React, { useState } from 'react';
import { OncologyQuiz } from './pages/OncologyQuiz';
import { BriefingQuestionnaire } from './pages/BriefingQuestionnaire';
export function App() {
  const [view, setView] = useState<'quiz' | 'briefing'>('quiz');
  return <div className="relative" data-id="element-0">
      {/* View toggle — fixed top-left, outside the quiz container */}
      <div className="fixed top-4 left-4 z-[200] flex bg-[#0B1623]/90 backdrop-blur-md border border-white/10 rounded-lg p-0.5 shadow-xl" data-id="element-1">
        <button onClick={() => setView('quiz')} className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all ${view === 'quiz' ? 'bg-[#4B9FE1] text-white shadow-sm' : 'text-slate-400 hover:text-white'}`} data-id="element-2">
          Quiz Preview
        </button>
        <button onClick={() => setView('briefing')} className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all ${view === 'briefing' ? 'bg-[#4B9FE1] text-white shadow-sm' : 'text-slate-400 hover:text-white'}`} data-id="element-3">
          Briefing Doc
        </button>
      </div>

      {view === 'quiz' ? <OncologyQuiz data-id="element-4" /> : <BriefingQuestionnaire data-id="element-5" />}
    </div>;
}